import * as React from 'react';
import Drawer from 'src/components/core/Drawer';
import { Hidden } from 'src/components/Hidden';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import PrimaryNav from './PrimaryNav/PrimaryNav';

const useStyles = makeStyles((theme: Theme) => ({
  menuPaper: {
    backgroundColor: theme.bg.primaryNavPaper,
    borderRight: 'none',
    boxShadow: 'none',
    height: '100%',
    width: 190,
    left: 'inherit',
    overflowX: 'hidden',
    transition: 'width linear .1s',
  },
  menuDocked: {
    height: '100%',
  },
  desktopMenu: {
    transform: 'none',
  },
  collapsedDesktopMenu: {
    width: 52,
    /**'&:hover': {
      overflowY: 'auto',
      width: 190,
      '& .primaryNavLink': {
        opacity: 1,
      },
    },*/
    [theme.breakpoints.up('sm')]: {
      overflowY: 'hidden',
    },
  },
}));

export interface Props {
  collapse: boolean;
  open: boolean;
  closeMenu: () => void;
}

type CombinedProps = Props;

export const SideMenu: React.FC<CombinedProps> = (props) => {
  const classes = useStyles();
  const { collapse, open, closeMenu } = props;

  return (
    <>
      <Hidden mdUp>
        <Drawer
          classes={{
            paper: classes.menuPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          onClose={closeMenu}
          open={open}
          variant="temporary"
        >
          <PrimaryNav closeMenu={closeMenu} isCollapsed={false} />
        </Drawer>
      </Hidden>
      <Hidden mdDown implementation="css">
        <Drawer
          classes={{
            paper: `${classes.menuPaper} ${
              collapse && classes.collapsedDesktopMenu
            }`,
            docked: classes.menuDocked,
          }}
          className={classes.desktopMenu}
          open
          variant="permanent"
        >
          <PrimaryNav closeMenu={closeMenu} isCollapsed={collapse} />
        </Drawer>
      </Hidden>
    </>
  );
};

export default SideMenu;
